export function isNumber(value: unknown): boolean {
  return typeof value === 'number' && Number.isFinite(value);
}

export function getPositiveNumber(value: number | null): number | null {
  const num = Number(value);
  return isNumber(num) && num > 0 ? num : null;
}
